import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Polls WhatsApp connection for the counselor and alerts if the session drops. */
export default function WhatsAppMonitor() {
  const navigate = useNavigate();
  const wasConnected = useRef(false);
  const notified = useRef(false);

  useEffect(() => {
    let timer;
    const check = async () => {
      try {
        const { data } = await api.get("/whatsapp/connection");
        if (data.connected) {
          wasConnected.current = true;
          notified.current = false;
        } else if (wasConnected.current && !notified.current) {
          notified.current = true;
          toast.error("انقطع اتصال واتساب المدرسة. أعد مسح رمز QR للمتابعة.", {
            id: "wa-drop",
            duration: 20000,
            action: { label: "إعادة المسح", onClick: () => navigate("/app/whatsapp") },
          });
        }
      } catch { /* ignore */ }
    };
    check();
    timer = setInterval(check, 15000);
    return () => clearInterval(timer);
  }, [navigate]);

  return null;
}
